module.exports = __webpack_public_path__ + "img/dashboard-svgrepo-com.cd6a146d.svg";